import {RouterProps} from "../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {EnvBankValueObject} from "../../../data/value-object/env/EnvBankValueObject";
import {useEffect} from "react";
import {EnvBankIO} from "../../../io/EnvIO";
import {Body1, Caption1Strong, Spinner, Tab, TabList} from "@fluentui/react-components";
import {DetailDefaultPanel} from "../../DetailViews";
import {EnvBankDescription} from "../../../data/description/env/EnvBankDescription";
import {EnvBankDomain} from "../../../data/domain/env/EnvBankDomain";
import {EnvBankDescriptor} from "../../../data/descriptor/env/EnvBankDescriptor";
import {MediaFile, Media} from "../../Media";
import {StorageKey} from "../../../io/StorageIO";

enum Panel {
    Default,
}

export default function Detail(props: RouterProps) {
    const params = useParams<{ envBankId: string }>()
    const item = useStatePair<EnvBankValueObject | undefined>(undefined)
    const icon = useStatePair<MediaFile | undefined>(undefined)

    useEffect(() => {
        if (params.envBankId !== undefined) {
            const id = BigInt(params.envBankId)
            EnvBankIO
                .getById(id)
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
            MediaFile
                .createFromStorageKey(StorageKey.Env.bank(id))
                .then(icon.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('아이콘을 찾을 수 없습니다. 아이콘을 먼저 수정해주세요.')
                    document.location = document.location.pathname + '/edit'
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && icon.value !== undefined && <>
            <Page
                {...props}
                item={item.value}
                icon={icon.value} />
        </>}
    </>
}

type PageProps = RouterProps & {
    item: EnvBankValueObject
    icon: MediaFile
}

function Page(props: PageProps) {
    const panel = useStatePair<Panel>(Panel.Default)

    return <>
        <div className={props.styles.row16}>
            <TabList
                selectedValue={panel.value}
                onTabSelect={(_, data) => panel.setter(data.value as Panel)}
                vertical>
                <Tab value={Panel.Default}>상세</Tab>
            </TabList>
            <DetailDefaultPanel
                {...props}
                visible={panel.value === Panel.Default}
                client={EnvBankIO}
                description={EnvBankDescription}
                properties={props => <PropertyBody {...props} />}
                panelChildren={<>
                    <Caption1Strong>아이콘</Caption1Strong>
                    <Media
                        {...props}
                        index={0}
                        source={props.icon} />
                </>}/>
        </div>
    </>
}

type PropertyBodyProps = Omit<PageProps, 'icon'> & {
    itemKey: keyof EnvBankDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "name":
        case "displayOrder":
        case "assetSolarWithdrawalCount":
        case "createdAt":
        case "lastModifiedAt":
        case "concealedAt":
            return <Body1>{EnvBankDescriptor[props.itemKey](props.item)}</Body1>
        case "creatorId":
            return <a href={`/users/${props.item.creatorId}`}><Body1>{EnvBankDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}